import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import {
  AllLoadingEquipment,
  AllLoadingEquipmentDeploymentSummaryReport,
} from "../../../Apis/loadingEquipmentApi";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import Loader from "../../../Common/Loader/loader";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { AllOwnerTypeDetails } from "../../../Apis/ownerTypeApi";
import { AllVehicleTypeDetails } from "../../../Apis/vehicleApi";
import { AllShiftMaster } from "../../../Apis/shiftMasterApi";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import { useNavigate } from "react-router-dom";
import { CreatableSelect } from "@atlaskit/select";
import isGHMC, { getCurrentDate, getCurrentDateTime, getStartOfCurrentDate } from "../../../Common/helper/helpar";
import { getNowDateTime, getOneMonthPastDateTime } from "../../AssetVehicle/utils/helpers";

const LoadingEquipmentDeploymentSummaryReport = ({ t }) => {
  const headers = [
    "zone",
    "circle",
    "ownerType",
    "allotedLe",
    "deployedLe",
    "allotedWorkingHrs",
    "actualWorkingHrs",
    "deductionHrs",
  ];
  const navigate = useNavigate();

  const [getAllTripsTonnage, setAllTripsTonnage] = useState([]);
  const [startDate, setStartDate] = useState(getStartOfCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [isLoading, setIsLoading] = useState(false);
  const [ownerTypeDetails, setOwnerTypeDetails] = useState([]);
  const [optionsValues, setOptionsValues] = useState([]);
  const [vehicleTypeOptionsValues, setVehicleTypeOptionsValues] = useState([]);
  const [optionsLoadingValues, setOptionLoadingValues] = useState([]);
  const [selectedOwnerType, setSelectedOwnerType] = useState([]);
  const [vehicleTypeDetails, setVehicleTypeDetails] = useState([]);
  const [selectedVehicleType, setSelectedVehicleType] = useState([]);
  const [loadingEquipments, setLoadingEquipments] = useState([]);
  const [shiftType, setShiftType] = useState([]);
  const [selectedShift, setSelectedShift] = useState("");
  const isProd = isGHMC();

  useEffect(() => {
    fetchTripsTonnageData(startDate, endDate, selectedShift);
  }, []);

  useEffect(() => {
    const fetchOwnerTypeData = async () => {
      try {
        const ownerTypeData = await AllOwnerTypeDetails();
        setOwnerTypeDetails(ownerTypeData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };
    console.log(selectedOwnerType, "selectedowner");
    fetchOwnerTypeData();
  }, [selectedOwnerType]);

  localStorage.setItem("startDate", startDate);
  localStorage.setItem("endDate", endDate);

  useEffect(() => {
    const fetchVehicleTypeData = async () => {
      try {
        const vehicleTypeData = await AllVehicleTypeDetails();
        setVehicleTypeDetails(vehicleTypeData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };

    fetchVehicleTypeData();
  }, []);

  useEffect(() => {
    const fetchLoadingEquipments = async () => {
      try {
        const loadingEquipmentsData = await AllLoadingEquipment();
        setLoadingEquipments(loadingEquipmentsData);
      } catch (error) {
        console.error("Error fetching loading equipments:", error);
      }
    };

    fetchLoadingEquipments();
  }, []);

  useEffect(() => {
    localStorage.setItem("selectedOwnerType", selectedOwnerType);
  }, [selectedOwnerType]);

  const fetchTripsTonnageData = async (startDate, endDate) => {
    try {
      setIsLoading(true);
      const response = await AllLoadingEquipmentDeploymentSummaryReport(
        startDate,
        endDate,
        selectedShift,
        selectedOwnerType,
        selectedVehicleType
      );
      const formattedData = response.map((item) => ({
        ...item,
        zone: item.zoneName,
        circle: item.circleName,
        ownerType: item.ownerTypeName,
        vehicleType: item.vehicleTypeName,
        allotedLe: item.allotedLE,
        deployedLe: item.deployedLE,
        allotedWorkingHrs: item.allotedWorkingHrs,
        actualWorkingHrs: item.actualWorkingHrs,
        deductionHrs: item.deductionHours,
      }));
      setAllTripsTonnage(formattedData);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchShiftData = async () => {
      try {
        const shiftData = await AllShiftMaster();
        setShiftType(shiftData);
      } catch (error) {
        console.error("Error fetching shift data:", error);
      }
    };

    fetchShiftData();
  }, []);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    await fetchTripsTonnageData(startDate, endDate, selectedShift);
  };

  useEffect(() => {
    setOptionsValues(
      ownerTypeDetails
        .filter((ownerType) => ownerType.isActive)
        .map((ownerType) => ({
          value: ownerType.ownerTypeId,
          label: ownerType.ownerTypeName,
        }))
    );
  }, [ownerTypeDetails]);

  const handleChange = (newValue, actionMeta) => {
    if (actionMeta.action === "select-option") {
      setSelectedOwnerType(newValue.value);
    } else if (actionMeta.action === "create-option") {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedOwnerType(newValue.value);
    } else {
      if (actionMeta.action === "clear") {
        setSelectedOwnerType(null);
      }
    }
  };

  const handleVehicleTypeChange = (newValue, actionMeta) => {
    if (actionMeta.action === "select-option") {
      setSelectedVehicleType(newValue.value);
    } else if (actionMeta.action === "create-option") {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedVehicleType(newValue.value);
    } else {
      if (actionMeta.action === "clear") {
        setSelectedVehicleType(null);
      }
    }
  };

  const sumTime = (timeArray) => {
    let totalMinutes = timeArray.reduce((sum, time) => {
      if (!time) return sum;
      const [hours, minutes] = time.split(":").map(Number);
      return sum + hours * 60 + minutes;
    }, 0);
    const totalHours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;
    return `${String(totalHours).padStart(2, "0")}:${String(remainingMinutes).padStart(2, "0")}`;
  };

  const totalAllotedLE = getAllTripsTonnage.reduce((sum, row) => sum + (row.allotedLE || 0), 0);
  const totalDeployedLE = getAllTripsTonnage.reduce((sum, row) => sum + (row.deployedLE || 0), 0);
  const totalAllotedWorkingHrs = sumTime(getAllTripsTonnage.map((row) => row.allotedWorkingHrs));
  const totalActualWorkingHrs = sumTime(getAllTripsTonnage.map((row) => row.actualWorkingHrs));
  const totalDeductionHrs = sumTime(getAllTripsTonnage.map((row) => row.deductionHours));
  const totalRow = {
    zoneName: "",
    circleName: "",
    ownerTypeName: "Total",
    allotedLE: totalAllotedLE,
    deployedLE: totalDeployedLE,
    allotedWorkingHrs: totalAllotedWorkingHrs,
    actualWorkingHrs: totalActualWorkingHrs,
    deductionHours: totalDeductionHrs,
  };

  // Conditionally include totalRow only if there is data
  const displayedRows = getAllTripsTonnage.length > 0
    ? [...getAllTripsTonnage, totalRow]
    : getAllTripsTonnage;

  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date().toLocaleString("en-GB", options).replace(/\//g, "/")}`;
  const downloadAsExcel = async () => {
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Loading Equipment Deployment Summary Report`;
    const downloadDateTime = `Report on: ${generationTime},${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("LoadingEquipmentDeploymentSummaryReport");
    const boldFont = { bold: true };

    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 7);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 11; col++) {
      worksheet.getCell(1, col).font = boldFont;
      worksheet.getCell(1, col).alignment = { horizontal: "center" };
    }

    worksheet.addRow(["", "", "Loading Equipment Deployment Summary Report", ""]);
    worksheet.mergeCells(2, 2, 2, 7);
    worksheet.getCell(2, 2).value = "Loading Equipment Deployment Summary Report";
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 11; col++) {
      worksheet.getCell(2, col).font = boldFont;
      worksheet.getCell(2, col).alignment = { horizontal: "center" };
    }

    worksheet.addRow([""]);

    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Zone",
      "Circle",
      "Vehicle Type",
      "Owner Type",
      "Alloted LE",
      "Deployed LE",
      "Alloted Working Hrs",
      "Actual Working Hrs",
      "Deduction Hrs",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 10) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" },
        };
      }
    });

    displayedRows.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.zoneName?? "N/A",
        item.circleName?? "N/A",
        item.vehicleTypeName?? "N/A",
        item.ownerTypeName?? "N/A",
        item.allotedLE?? "N/A",
        item.deployedLE?? "N/A",
        item.allotedWorkingHrs?? "N/A",
        item.actualWorkingHrs?? "N/A",
        item.deductionHours?? "N/A",
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 10) {
          cell.alignment = { horizontal: "left" };
        } else {
          cell.alignment = { horizontal: "center" };
        }
      });
    });

    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "LoadingEquipmentDeploymentSummaryReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  useEffect(() => {
    setVehicleTypeOptionsValues(
      vehicleTypeDetails.map((vehicleType) => ({
        value: vehicleType.vehicleTypeId,
        label: vehicleType.vehicleTypeName,
      }))
    );
  }, [vehicleTypeDetails]);

  useEffect(() => {
    setOptionLoadingValues(
      loadingEquipments.map((LoadingEquipment) => ({
        value: LoadingEquipment.loadingEquipmentId,
        label: LoadingEquipment.loadingEquipmentNumber,
      }))
    );
  }, [loadingEquipments]);

  useEffect(() => {
    localStorage.setItem("selectedOwnerType", selectedOwnerType);
  }, [selectedOwnerType]);

  const columns = [
    {
      name: "S.No",
      selector: (row) => row["sno"],
      format: (row, rowIndex) => rowIndex + 1,
      width: "70px",
    },
    {
      name: "Zone",
      selector: (row) => <span>{row["zoneName"]}</span>,
      width: "120px",
    },
    {
      name: "Circle",
      selector: (row) => <span>{row["circleName"]}</span>,
      width: "120px",
    },
    {
      name: "Vehicle Type",
      selector: (row) => <span>{row["vehicleTypeName"]}</span>,
      width: "150px",
    },
    {
      name: "Owner Type",
      selector: (row) => <span>{row["ownerTypeName"]}</span>,
      width: "150px",
    },
    {
      name: "Alloted LE",
      selector: (row) => <span>{row["allotedLE"]}</span>,
      width: "120px",
    },
    {
      name: "Deployed LE",
      selector: (row) => (
        <span
          style={
            row.ownerTypeName === "Total"
              ? { color: "black" }
              : { color: "blue", cursor: "pointer" }
          }
          onClick={
            row.ownerTypeName !== "Total" ? () => handleDeployedLEClick(row) : undefined
          }
        >
          {row["deployedLE"]}
        </span>
      ),
      width: "120px",
    },
    {
      name: <>Alloted Working Hrs</>,
      selector: (row) =>
         <span>{row["allotedWorkingHrs"]}</span>,
      width: "150px",
    },
    {
      name: "Actual Working Hrs",
      selector: (row) => <span>{row["actualWorkingHrs"]}</span>,
    },
    {
      name: "Deduction Hrs",
      selector: (row) => <span>{row["deductionHours"]}</span>,
    },
  ];

  const handleDeployedLEClick = (row) => {
    navigate("/loading_equipment_inner_certification-report", {
      state: {
        startDate,
        endDate,
        ownerTypeId: row.ownerTypeId,
        vehicleTypeId: row.vehicleTypeId,
        shiftId: selectedShift,
        zoneId: row.zoneId,
        circleId: row.circleId,
      },
    });
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div style={{ width: "100%" }}>
          <div className="content">
            <div className="page-content">
              <h4 className="text-start mb-3">{t("Loading Equipment Deployment Summary ")}</h4>
              <div className="card">
                <div className="card-body p-3">
                  <div className="row align-items-end">
                    <div className="col-md-12">
                      <form
                        className="row align-items-end"
                        onSubmit={handleFormSubmit}
                        style={{ textAlign: "justify" }}
                      >
                        <div className="col-md-2">
                          <label> From Date:</label>
                          <input
                            type="datetime-local"
                            name="FromDate"
                            className="form-control"
                            style={inputStyle}
                            value={startDate}
                            min={getOneMonthPastDateTime()}
                            max={getNowDateTime()}
                            onChange={(e) => setStartDate(e.target.value)}
                          />
                        </div>
                        <div className="col-md-2">
                          <label> To Date:</label>
                          <input
                            type="datetime-local"
                            name="ToDate"
                            style={inputStyle}
                            value={endDate}
                            className="form-control"
                            // min={startDate}
                            max={getCurrentDateTime()}
                            onChange={(e) => setEndDate(e.target.value)}
                          />
                        </div>
                        <div className="col-md-2">
                          <label htmlFor="shift">Shift:</label>
                          <select
                            className="form-select"
                            style={inputStyle2}
                            name="shiftId"
                            id="shift"
                            value={selectedShift}
                            onChange={(e) => setSelectedShift(e.target.value)}
                          >
                            <option value="">Select</option>
                            {shiftType
                              .filter((shift) => shift.isActive)
                              .map((shift) => (
                                <option key={shift.shiftId} value={shift.shiftId}>
                                  {shift.shiftName}
                                </option>
                              ))}
                          </select>
                        </div>
                        <div className="col-md-2">
                          <label htmlFor="ownerType">Owner Type:</label>
                          <CreatableSelect
                            classNamePrefix="CreatableSelect"
                            inputId="ownerType"
                            name="ownerTypeId"
                            id="ownerType"
                            placeholder="Select"
                            options={optionsValues}
                            isClearable={true}
                            onChange={handleChange}
                            onCreateOption={(inputValue) => {
                              const newValue = {
                                label: inputValue,
                                value: inputValue.toLowerCase(),
                              };
                              if (inputValue) {
                                setSelectedOwnerType(newValue.value);
                                setOptionsValues((prevOptions) => [...prevOptions, newValue]);
                              } else {
                                setSelectedOwnerType("");
                              }
                            }}
                            value={optionsValues.find(
                              (option) => option.value === selectedOwnerType
                            )}
                          />
                        </div>
                        <div className="col-md-2">
                          <label htmlFor="VehicleType">Vehicle Type:</label>
                          <CreatableSelect
                            classNamePrefix="CreatableSelect"
                            inputId="vehicleType"
                            name="vehicleTypeId"
                            id="vehicleType"
                            placeholder="Select"
                            options={vehicleTypeOptionsValues}
                            isClearable={true}
                            onChange={handleVehicleTypeChange}
                            onCreateOption={(inputValue) => {
                              const newValue = {
                                label: inputValue,
                                value: inputValue.toLowerCase(),
                              };
                              inputValue && newValue
                                ? setSelectedVehicleType(newValue.value)
                                : setSelectedVehicleType("");
                            }}
                            value={vehicleTypeOptionsValues.find(
                              (option) => option.value === selectedVehicleType
                            )}
                          />
                        </div>
                        <div className="col-md-2">
                          <div className="d-flex justify-content-between align-items-center">
                            <button
                              type="submit"
                              className={`btn mt-2 ${isProd ? "search-ghmc" : "search-swm"}`}
                            >
                              Search
                            </button>
                            <button
                              className="btn-excel ms-auto mt-4"
                              onClick={downloadAsExcel}
                            >
                              <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="mt-3">
                    <CustomDataTable data={displayedRows} columns={columns} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// Styles for input and button
const inputStyle = {
  backgroundColor: "#fff",
  height: "38px",
  border: "1px solid #E2E2E2",
  padding: "15px",
  borderRadius: "0px",
};

const inputStyle2 = {
  backgroundColor: "#fff",
  height: "38px",
  border: "1px solid #E2E2E2",
  borderRadius: "0px",
};

const buttonStyle = {};

const createOption = (label) => ({
  label,
  value: label.toLowerCase().replace(/\W/g, ""),
});

export default withTranslation()(LoadingEquipmentDeploymentSummaryReport);